@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.input {
  font-size: 14px;
  &:not(:placeholder-shown) + label,
  &:focus + label {
    top: -9px;
    font-size: 12px;
    left: 20px;
  }
}

input[type='date'] {
  position: relative;

  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    right: 0;
    z-index: 1;
    cursor: pointer;
  }

  &::-moz-focus-inner {
    border: 0;
  }
}
